module.exports = __webpack_public_path__ + "static/media/AtlasGrotesk-Regular.53b1f95b.otf";